import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form"
export default class extends Controller {

  static values = { focus: String }
  static targets = ["focus"]
  
  connect() {
    this.focusFirstError()
    this.hasFocusTarget && this.focusTarget.focus()
  }

  focusFirstError() {
    setTimeout(() => {
      const firstErrorItem = this.element.querySelector(".form-item.error")

      if (!firstErrorItem) return

      const trixError = firstErrorItem.querySelector("trix-editor")

      if (trixError) {
        trixError.focus()
      } else {
        const errorElement = firstErrorItem.querySelector("input:not([type=hidden]), select:not([type=hidden]), textarea:not([type=hidden])")
        if (errorElement) {
          errorElement.tomselect ? errorElement.tomselect.focus() : errorElement.focus()
        }
      }
    }, 50)
  }

  prevent(e) {
    e.preventDefault()
  }
  
}
